import React from 'react';
import { Table } from 'antd';
import { DiscountRulesForServiceProvider } from 'Common/functions/getDiscountRulesForServiceProvider';
import { DiscountType } from 'Generated/graphql';
import { formatDiscountValue } from '../DiscountRuleProgress/fn';

type discountRule = Pick<DiscountRulesForServiceProvider[number], 'discountValue' | 'triggerCondition' | 'discountType'>

type ServiceProviderDiscountRulesTableProps = {
  discountRules: discountRule[];
  serviceProviderDisplayName?: string;
  hideCopy?: boolean;
}

const ServiceProviderDiscountRulesTable: React.FC<ServiceProviderDiscountRulesTableProps> = ({
  discountRules,
  serviceProviderDisplayName,
  hideCopy = false,
}) => {
  const columns = [
    {
      title: null,
      dataIndex: 'triggerCondition',
      key: 'discountType',
      render: (value: DiscountType, { discountRule: rule }: { discountRule: discountRule; key: string; }) => {
        const tc = rule.triggerCondition;
        const requireDurationBookedSeconds = tc.timeDurationBookedAtLocationTriggerCondition?.requireDurationBookedSeconds || 0;
        const requireBookingCount = tc.siblingBookingTriggerCondition?.requireBookingCount || 0;

        const s = requireDurationBookedSeconds > 3600 || requireBookingCount > 1 ? 's' : '';
        const copy = requireDurationBookedSeconds ?
          `${requireDurationBookedSeconds / 3600} hour${s}` :
          `${requireBookingCount} booking${s}`;

        return (
          <span className="lg:text-lg">{copy}</span>
        );
      }
    },
    {
      title: null,
      dataIndex: 'discountValue',
      key: 'discountValue',
      render: (value: number, { discountRule: obj }: { discountRule: discountRule; key: string; }) => {
        const copy = formatDiscountValue(obj.discountValue, obj.discountType);

        return (
          <div className="flex justify-start ">
            <span className="py-2 px-4 bg-[#fef1ee] text-primary uppercase rounded font-bold">
              {copy} OFF
            </span>
          </div>
        );
      },
    },
  ];

  return (
    <div className="flex flex-col gap-6 lg:max-w-96">
      <div className="flex flex-col gap-2">
        {hideCopy || (
          <span>
            {serviceProviderDisplayName || 'This provider'} offers discounts for group bookings when multiple appointments are booked at the same place on the same date.
          </span>
        )}
      </div>
      <Table
        dataSource={discountRules.map((discountRule, i) => ({
          discountRule,
          key: i.toString(),
        }))}
        columns={columns}
        pagination={false}
        bordered
        className="border border-gray-200 border-solid rounded-xl"
        showHeader={false}
      />
    </div>
  );
};

export default ServiceProviderDiscountRulesTable;

